<ng-container 
  libGtmInitializer 
  [autoTrackPageView]="true"
  [requireAuthentication]="true">
  <router-outlet></router-outlet>
</ng-container>